import {
    Box,
    Chip
} from '@mui/material';
import { FC } from 'react';
import { formatHippodromeName } from '../../../../../utils/format';
import { CourseFilter, Programme } from '../../../services/type';
import { useSearchParams } from 'react-router-dom';

type Props = {
    filter: CourseFilter;
    programme: Programme;
};

const ReunionFilter: FC<Props> = ({ filter, programme }) => {
    const [searchParam, setSearchParams] = useSearchParams();
    const options = programme.reunions.map((r) => {
        return {
            num: r.numOfficiel,
            hippodrome: r.hippodrome.libelleLong,
        };
    });

    const handleclick = (value: number) => {
        const params = new URLSearchParams(searchParam);
        if (filter.reunion === value) {
            params.delete('reunion');
        } else {
            params.set('reunion', String(value));
        }
        setSearchParams(params, { replace: true });
    };

    return (
        <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
            {options.map(option => (
                <Chip
                    component="span"
                    label={`R${option.num} • ${formatHippodromeName(option.hippodrome)}`}
                    onClick={() => handleclick(option.num)}
                    sx={{
                        m: 0.5,
                        px: 0.5,
                        fontSize: 11,
                        fontWeight: 700,
                        letterSpacing: 0.3,
                        borderRadius: '8px',
                        color: 'white',
                        bgcolor:
                            filter.reunion === option.num
                                ? 'secondary.main'
                                : 'primary.light',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            bgcolor: 'secondary.main',
                            transform: 'scale(1.05)',
                        },
                    }}
                />
            ))}
        </Box>
    );

};

export default ReunionFilter;
